const KEY = 'goodtime.realmMap';

function remembered(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

function remember(on: boolean): void {
  try {
    if (on === remembered()) return;
    if (on) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // Storage off (private mode): the flag still applies once loaded.
  }
}

/**
 * Whether the realm map (flag realm_map) is the player's home screen. The
 * flag arrives with the player fetch, a moment after launch; until then the
 * last answer stands, so a flagged player doesn't see the episode list
 * flash first. A plain function rather than a hook, for App's sake.
 */
export function realmHome(flagOn: boolean, playerLoaded: boolean): boolean {
  if (!playerLoaded) return flagOn || remembered();
  remember(flagOn);
  return flagOn;
}

const TITLE_KEY = 'goodtime.realmTitleSeen';

/** Whether the map's title plaque ("The Goodtime Realms") has been shown on
 *  this device: it shows on the map's first view only. */
export function realmTitleSeen(): boolean {
  try {
    return localStorage.getItem(TITLE_KEY) === '1';
  } catch {
    // Storage off (private mode): show it, once per launch at most.
    return false;
  }
}

export function markRealmTitleSeen(): void {
  try {
    localStorage.setItem(TITLE_KEY, '1');
  } catch {
    // Storage off: nothing to remember it in.
  }
}
